import React, { useState, useEffect } from "react";

import { AiFillStar, AiOutlineStar } from "react-icons/ai";
import { Star } from "@material-ui/icons";

export default function RatingStars({ initRating, onRatingChanged }: any) {
  const [rating, setRating] = useState<any>(initRating);
  useEffect(() => {
    setRating(initRating);
  }, [initRating]);
  /**
   * Update Rating to Post
   * @param {any} newRating
   */
  function changeRating(newRating: any) {
    setRating(newRating);
    onRatingChanged(newRating);
  }
  return (
    <div className="stars-wrapper">
      <span>悪い</span>
      {[...Array(5)].map((star, index) => {
        index += 1;
        return (
          <button
            type="button"
            key={index}
            className={
              index <= rating ? "rating-on rating-btn" : "rating-off rating-btn"
            }
            onClick={() => changeRating(index)}
          >
            <span className="star">
              {index <= rating ? (
                <AiFillStar style={{ fill: "#FBBF42" }} />
              ) : (
                <AiOutlineStar style={{ fill: "#E6E6E6" }} fontSize="large" />
              )}
            </span>
          </button>
        );
      })}
      <span>良い</span>
    </div>
  );
}
